module.exports = __webpack_public_path__ + "static/media/dove.90001e93.svg";